import React from 'react'
import { connect } from 'react-redux'
import useAuth from 'components/auth/useAuth'
import { UnfoundMembershipDialog } from 'member-portal/components'
import MemberApplicationLayout from 'member-portal/member_application/Layout'
import { AllMembershipsType } from 'types'
import { selectors } from '../reducer'
import { hasMembershipHistory, makeMarketingSitePath, PATH } from 'config'
import Dashboard from './Dashboard'

const propTypes = {
  allMemberships: AllMembershipsType,
}

function MembershipLanding({ allMemberships = null }) {
  const { logout } = useAuth()

  const logoutAndReturnToApp = () =>
    logout({
      logoutParams: { returnTo: makeMarketingSitePath(PATH.SEATOW_LOGOUT) },
    })

  if (hasMembershipHistory(allMemberships?.memberships)) {
    return <Dashboard />
  }

  return (
    <MemberApplicationLayout>
      <UnfoundMembershipDialog logoutAndReturnToApp={logoutAndReturnToApp} />
    </MemberApplicationLayout>
  )
}

MembershipLanding.propTypes = propTypes

function mapStateToProps(state) {
  return {
    allMemberships: selectors.allMemberships(state),
  }
}

export default connect(mapStateToProps)(MembershipLanding)
